/**
 * CfssServiceAuthPage — CFSS Service Authorization Tracking
 *
 * MN 256B.85: CFSS service authorizations from lead agency
 * Thin wrapper around shared ServiceAuthorizationPage with CFSS config.
 *
 * Route: /cfss/authorizations
 */

import { ServiceAuthorizationPage } from '@/pages/shared-services';

export function CfssServiceAuthPage() {
  return (
    <ServiceAuthorizationPage
      title="Service Authorizations"
      subtitle="Your approved CFSS services from the lead agency"
      serviceLabel="Service"
      agencyLabel="Lead Agency"
      scope="cfss:auth:view"
    />
  );
}

export default CfssServiceAuthPage;
